<template>

    <div class="relative mt-10 mb-5 rounded-lg collapseCardTable themeCards pt-2" v-if="!isMobile">
        <div class="absolute z-10 top-3 right-3">
            <hrm-button v-if="filterConfig?.showClose !== false" @click="close" buttonMode="iconButton" iconSize="16px"
                buttonPadding="0" buttonSize="30px" buttonClass="flex justify-center items-center hrm_close_button"
                buttonAlign="center" icon="ep:close-bold" tooltipText="Close Filter" tooltipPosition="left" />
        </div>
        <div class="relative p-5 rounded-sm">
            <div class="hrm_filter_grid grid grid-cols-5 gap-6 mr-0 xl:mr-48">
                <!-- :class="filterData.fromDate ? 'hrm_selected_value' : ''" -->

                <template v-for="(filterItem, filterItemIndex) in filterConfig.fields" :key="filterItemIndex">

                    <div class="theme-input" v-if="filterItem.type == 'dateFilter'">
                        <label class="text-sm font-medium text-gray-800 dark:text-gray-400">
                            {{ filterItem.label ? filterItem.label : trans('lang.labels.start_date_end_date') }}
                        </label>
                        <div class="relative mt-2">
                            <VueDatepickerFilter :key="filterKey" ref="datePicker"
                                :placeholder="trans('lang.labels.start_date_end_date')"
                                @getDateRange="getDateRangeValue($event, filterItem)" :formatDate="filterItem.format"
                                :minDate="filterItem.minDate" />

                        </div>
                    </div>
                    <div class="theme-input" v-if="filterItem.type == 'weekPicker'">
                        <label class="text-sm font-medium text-gray-800 dark:text-gray-400">
                            {{ filterItem.label ? filterItem.label : trans('lang.labels.week_days') }}
                        </label>
                        <div class="relative mt-2">
                            <WeekPicker :key="filterKey" ref="datePicker" :placeholder="filterItem.label"
                                @getDateRange="getWeekPickerValue($event, filterItem)" />

                        </div>
                    </div>
                    <div class="theme-input" v-else-if="filterItem.type == 'monthYear'">
                        <label class="text-sm font-medium text-gray-800 dark:text-gray-400">
                            {{ trans("lang.labels.month_year") }}
                        </label>
                        <div class="relative mt-2">
                            <DatePicker :vTimePicker="false" :key="filterKey"
                                @submitDate="getMonthYear($event, filterItem)" :vMonthPicker="true" :vEnableTime="false"
                                :placeholder="trans('lang.labels.select_month_year')"></DatePicker>
                        </div>
                    </div>
                    <div class="theme-input" v-else-if="filterItem.type == 'year'">
                        <label class="text-sm font-medium text-gray-800 dark:text-gray-400">
                            {{ trans("lang.labels.year") }}
                        </label>
                        <div class="relative mt-2">
                            <DatePicker :key="filterKey" :vTimePicker="false" :vEnableTime="false" :vYearPicker="true"
                                @submitDate="getYear($event, filterItem)"
                                :placeholder="trans('lang.labels.select_year')" />
                        </div>
                    </div>
                    <div class="theme-input" v-else-if="filterItem.type == 'datePicker'">
                        <label class="text-sm font-medium text-gray-800 dark:text-gray-400">
                            {{ trans("lang.labels.date") }}
                        </label>
                        <div class="relative mt-2">
                            <VueDatePicker :key="filterKey" v-model="filterData[filterItem.models]" auto-apply
                                :enable-time-picker="false" :placeholder="trans('lang.labels.select_month_year')" />
                        </div>
                    </div>
                    <div class="theme-input" v-else-if="filterItem.type == 'remoteOptions'">
                        <label class="text-sm font-medium text-gray-800 dark:text-gray-400">
                            {{ filterItem.label }}
                        </label>
                        <div class="relative mt-2">
                            <VueMultiselect :key="filterKey" class="hrm-vuemultiselect"
                                v-model="filterData[filterItem.models]" :options="filterItem.options"
                                :placeholder="trans('lang.labels.Select')" :label="filterItem.itemLabel"
                                :valueProp="filterItem.itemValue" :searchable="true" />
                        </div>
                    </div>
                    <div class="theme-input" v-else-if="filterItem.type == 'presetOptions'">
                        <label class="text-sm font-medium text-gray-800 dark:text-gray-400">
                            {{ filterItem.label }}
                        </label>
                        <div class="relative mt-2">
                            <VueMultiselect :key="filterKey" class="hrm-vuemultiselect"
                                v-model="filterData[filterItem.models]" :options="filterItem.options"
                                :placeholder="trans('lang.labels.Select')" label="name" valueProp="value"
                                :searchable="true" />
                        </div>
                    </div>
                    <div class="theme-input" v-else-if="filterItem.type == 'customOptions'">
                        <label class="text-sm font-medium text-gray-800 dark:text-gray-400">
                            {{ filterItem.label }}
                        </label>
                        <div class="relative mt-2">
                            <VueMultiselect :key="filterKey" :mode="filterItem.selectMode" class="hrm-vuemultiselect"
                                v-model="filterData[filterItem.models]" :options="filterItem.options"
                                :placeholder="trans('lang.labels.Select')" :label="filterItem.itemLabel"
                                :valueProp="filterItem.itemValue" :searchable="true" />
                        </div>
                    </div>
                    <div class="theme-input" v-else-if="filterItem.type == 'manualEntry'">
                        <label class="text-sm font-medium text-gray-800 dark:text-gray-400">
                            {{ filterItem.label }}
                        </label>
                        <div class="relative mt-2">
                            <input :type="filterItem.fieldType" v-model="filterData[filterItem.models]"
                                class="block w-full mt-2 text-base text-gray-400 bg-gray-200 border border-gray-400 rounded-sm hrmInput_filter shadow-transparent dark:text-gray-100 dark:bg-gray-800 outline-0 focus:outline-0"
                                :placeholder="filterItem.label" />
                        </div>
                    </div>
                    <ProjectsTasks v-else-if="filterItem.type == 'projectTasks'" :filterItem="filterItem"
                        :filterData="filterData" />
                    <DesignationEmployee v-else-if="filterItem.type == 'employeeDesignation'" :filterItem="filterItem"
                        :filterData="filterData" />
                    <AssetCodeCategory v-else-if="filterItem.type == 'asset'" :filterItem="filterItem"
                        :filterData="filterData" />
                    <CountryStateCity v-else-if="filterItem.type == 'countryState'" :filterItem="filterItem"
                        :filterData="filterData" />
                    <WorkSourceProfile v-else-if="filterItem.type == 'worksource'" :filterItem="filterItem"
                        :filterData="filterData" />
                    <DataProvider v-else-if="filterItem.type == 'dataprovider'" :filterItem="filterItem"
                        :filterData="filterData" />
                    <ReminderFilter v-else-if="filterItem.type == 'reminder'" :filterItem="filterItem"
                        :filterData="filterData" />
                    <FollowDataProvider v-else-if="filterItem.type == 'followupdataprovider'" :filterItem="filterItem"
                        :filterData="filterData" />
                </template>
                <!-- Clear Button -->
                <div class="theme-input">
                    <label class="opacity-0 text-sm font-medium text-gray-800 dark:text-gray-400">
                        {{ trans("lang.labels.role") }}
                    </label>
                    <div class="flex items-center gap-2 ml-3 mt-2">
                        <button v-if="isShowUpdate" class="hrm_custom_icon_button hrm_button_hover buttongroup relative bg-hrmThemeBgColor 
                        text-hrmThemeTextColor rounded-lg flex justify-center items-center px-4 py-1.5 font-bold"
                            @click="updateFilter">
                            Filter
                        </button>
                        <span class="hrm_filter_clear flex items-center cursor-pointer text-red-400"
                            @click="clearFilters()">
                            {{ trans('lang.labels.clear') }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="fixed top-0 right-0 h-full w-[90%] max-w-[360px] md:hidden bg-nightColor-600 z-50 flex flex-col" v-else>

        <div
            class="flex items-center justify-between px-4 py-4  bg-hrmThemeBgColor text-hrmThemeTextColor flex-shrink-0">
            <h2 class="text-white text-lg font-semibold">Filters</h2>
            <button @click="close" class="text-white text-xl">✕</button>
        </div>


        <div class="flex-1 overflow-y-auto px-4  py-1 hrm_filter_grid">


            <template v-for="(filterItem, filterItemIndex) in filterConfig.fields" :key="filterItemIndex">

                <div class="theme-input" v-if="filterItem.type == 'dateFilter'">
                    <label class="text-sm font-medium text-gray-800 dark:text-gray-400">
                        {{ filterItem.label ? filterItem.label : trans('lang.labels.start_date_end_date') }}
                    </label>
                    <div class="relative mt-2">
                        <VueDatepickerFilter :key="filterKey" ref="datePicker"
                            :placeholder="trans('lang.labels.start_date_end_date')"
                            @getDateRange="getDateRangeValue($event, filterItem)" :formatDate="filterItem.format"
                            :minDate="filterItem.minDate" />

                    </div>
                </div>
                <div class="theme-input" v-if="filterItem.type == 'weekPicker'">
                    <label class="text-sm font-medium text-gray-800 dark:text-gray-400">
                        {{ filterItem.label ? filterItem.label : trans('lang.labels.week_days') }}
                    </label>
                    <div class="relative mt-2">
                        <WeekPicker :key="filterKey" ref="datePicker" :placeholder="filterItem.label"
                            @getDateRange="getWeekPickerValue($event, filterItem)" />

                    </div>
                </div>
                <div class="theme-input" v-else-if="filterItem.type == 'monthYear'">
                    <label class="text-sm font-medium text-gray-800 dark:text-gray-400">
                        {{ trans("lang.labels.month_year") }}
                    </label>
                    <div class="relative mt-2">
                        <DatePicker :vTimePicker="false" :key="filterKey" @submitDate="getMonthYear($event, filterItem)"
                            :vMonthPicker="true" :vEnableTime="false"
                            :placeholder="trans('lang.labels.select_month_year')"></DatePicker>
                    </div>
                </div>
                <div class="theme-input" v-else-if="filterItem.type == 'year'">
                    <label class="text-sm font-medium text-gray-800 dark:text-gray-400">
                        {{ trans("lang.labels.year") }}
                    </label>
                    <div class="relative mt-2">
                        <DatePicker :key="filterKey" :vTimePicker="false" :vEnableTime="false" :vYearPicker="true"
                            @submitDate="getYear($event, filterItem)" :placeholder="trans('lang.labels.select_year')" />
                    </div>
                </div>
                <div class="theme-input" v-else-if="filterItem.type == 'datePicker'">
                    <label class="text-sm font-medium text-gray-800 dark:text-gray-400">
                        {{ trans("lang.labels.date") }}
                    </label>
                    <div class="relative mt-2">
                        <VueDatePicker :key="filterKey" v-model="filterData[filterItem.models]" auto-apply
                            :enable-time-picker="false" :placeholder="trans('lang.labels.select_month_year')" />
                    </div>
                </div>
                <div class="theme-input" v-else-if="filterItem.type == 'remoteOptions'">
                    <label class="text-sm font-medium text-gray-800 dark:text-gray-400">
                        {{ filterItem.label }}
                    </label>
                    <div class="relative mt-2">
                        <VueMultiselect :key="filterKey" class="hrm-vuemultiselect"
                            v-model="filterData[filterItem.models]" :options="filterItem.options"
                            :placeholder="trans('lang.labels.Select')" :label="filterItem.itemLabel"
                            :valueProp="filterItem.itemValue" :searchable="true" />
                    </div>
                </div>
                <div class="theme-input" v-else-if="filterItem.type == 'presetOptions'">
                    <label class="text-sm font-medium text-gray-800 dark:text-gray-400">
                        {{ filterItem.label }}
                    </label>
                    <div class="relative mt-2">
                        <VueMultiselect :key="filterKey" class="hrm-vuemultiselect"
                            v-model="filterData[filterItem.models]" :options="filterItem.options"
                            :placeholder="trans('lang.labels.Select')" label="name" valueProp="value"
                            :searchable="true" />
                    </div>
                </div>
                <div class="theme-input" v-else-if="filterItem.type == 'customOptions'">
                    <label class="text-sm font-medium text-gray-800 dark:text-gray-400">
                        {{ filterItem.label }}
                    </label>
                    <div class="relative mt-2">
                        <VueMultiselect :key="filterKey" :mode="filterItem.selectMode" class="hrm-vuemultiselect"
                            v-model="filterData[filterItem.models]" :options="filterItem.options"
                            :placeholder="trans('lang.labels.Select')" :label="filterItem.itemLabel"
                            :valueProp="filterItem.itemValue" :searchable="true" />
                    </div>
                </div>
                <div class="theme-input" v-else-if="filterItem.type == 'manualEntry'">
                    <label class="text-sm font-medium text-gray-800 dark:text-gray-400">
                        {{ filterItem.label }}
                    </label>
                    <div class="relative mt-2">
                        <input :type="filterItem.fieldType" v-model="filterData[filterItem.models]"
                            class="block w-full mt-2 text-base text-gray-400 bg-gray-200 border border-gray-400 rounded-sm hrmInput_filter shadow-transparent dark:text-gray-100 dark:bg-gray-800 outline-0 focus:outline-0"
                            :placeholder="filterItem.label" />
                    </div>
                </div>
                <ProjectsTasks v-else-if="filterItem.type == 'projectTasks'" :filterItem="filterItem"
                    :filterData="filterData" />
                <DesignationEmployee v-else-if="filterItem.type == 'employeeDesignation'" :filterItem="filterItem"
                    :filterData="filterData" />
                <AssetCodeCategory v-else-if="filterItem.type == 'asset'" :filterItem="filterItem"
                    :filterData="filterData" />
                <CountryStateCity v-else-if="filterItem.type == 'countryState'" :filterItem="filterItem"
                    :filterData="filterData" />
                <WorkSourceProfile v-else-if="filterItem.type == 'worksource'" :filterItem="filterItem"
                    :filterData="filterData" />
                <DataProvider v-else-if="filterItem.type == 'dataprovider'" :filterItem="filterItem"
                    :filterData="filterData" />
                <ReminderFilter v-else-if="filterItem.type == 'reminder'" :filterItem="filterItem"
                    :filterData="filterData" />
                <FollowDataProvider v-else-if="filterItem.type == 'followupdataprovider'" :filterItem="filterItem"
                    :filterData="filterData" />
            </template>
            <!-- Clear Button -->
            <div class="theme-input">
                <label class="opacity-0 text-sm font-medium text-gray-800 dark:text-gray-400">
                    {{ trans("lang.labels.role") }}
                </label>
                <div class="flex items-center gap-2 ml-3 mt-2">
                    <button v-if="isShowUpdate" class="hrm_custom_icon_button hrm_button_hover buttongroup relative bg-hrmThemeBgColor 
                        text-hrmThemeTextColor rounded-lg flex justify-center items-center px-4 py-1.5 font-bold"
                        @click="updateFilter">
                        Filter
                    </button>
                    <span class="hrm_filter_clear flex items-end justify-end cursor-pointer text-red-400"
                        @click="clearFilters()">
                        {{ trans('lang.labels.clear') }}
                    </span>
                </div>
            </div>


            <div class="h-16"></div>
        </div>



    </div>
</template>
<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import VueMultiselect from '@vueform/multiselect';
import VueDatePicker from '@vuepic/vue-datepicker';
import DatePicker from "@/Common/DatePicker.vue";

import VueDatepickerFilter from "@/Components/Common/VueDatepickerFilter.vue";
import DesignationEmployee from './DesignationEmployee.vue';
import AssetCodeCategory from '../../../../Modules/Inventory/Resources/js/Components/AssetCodeCategory.vue';
import CountryStateCity from './CountryStateCity.vue';
import WorkSourceProfile from './WorkSourceProfile.vue';
import DataProvider from './DataProvider.vue';
import FollowDataProvider from './FollowDataProvider.vue';
import WeekPicker from './WeekPicker.vue';
import ReminderFilter from '@/Components/Reminder/ReminderFilter.vue';
import ProjectsTasks from './ProjectsTasks.vue';
const props = defineProps({
    filterData: Object,
    filterConfig: Object,
    isShowUpdate: {
        type: Boolean,
        default: false
    }
});
const emits = defineEmits(['close', 'updateFilter'])

const filterKey = ref(1);

const isMobile = ref(false);

const checkScreen = () => {
    isMobile.value = window.innerWidth < 768;
};

const close = () => {
    clearFilters('close');
    emits('close');
    if (props.isShowUpdate) {
        updateFilter();
    }
};

const updateFilter = () => {
    emits('updateFilter');
}

const getDateRangeValue = (dateValue, filterItem) => {
    if (dateValue && dateValue.startDate != '') {
        props.filterData[filterItem?.models?.startDate] = dateValue.startDate
        props.filterData[filterItem?.models?.endDate] = dateValue.endDate
    } else {
        props.filterData[filterItem?.models?.startDate] = null
        props.filterData[filterItem?.models?.endDate] = null
    }
};

const getWeekPickerValue = (dateValue, filterItem) => {
    if (dateValue && dateValue[0] && dateValue[0]) {
        props.filterData.weekDays = dateValue;
    } else {
        props.filterData.weekDays = null
    }
}

const getRemoteOptions = (url, filterItem) => {
    let query = {
        perPage: "all",
        status: 1,
        ...filterItem?.query
    }
    axios
        .get(route(url), { params: query })
        .then((response) => {
            filterItem.options = [...response.data.data];
            if (filterItem.defaultValue) {
                props.filterData[filterItem.models] = filterItem.defaultValue;
            }
        })
        .catch((error) => { })
        .finally(() => { });
}

const getMonthYear = (event, filterItem) => {
    const newMonthYear = {
        ...event,
        month: event?.month + 1,
    };
    if (isNaN(newMonthYear.month)) {
        props.filterData[filterItem.models] = null;
        return;
    }
    if (filterItem.dateFormat === 'MM/YYYY') {
        props.filterData[filterItem.models] = newMonthYear;
        return;
    }
    const formattedDate = `${newMonthYear.year}-${String(newMonthYear.month).padStart(2, '0')}-01`;
    props.filterData[filterItem.models] = formattedDate;

}
const getYear = (event, filterItem) => {


    if (!event || isNaN(event)) {
        props.filterData[filterItem.models] = null;
        return;
    }

    // If you only want to send year number
    if (filterItem.dateFormat === 'YYYY') {
        props.filterData[filterItem.models] = event;
        return;
    }

    props.filterData[filterItem.models] = event;
};

const clearFilters = () => {
    Object.keys(props.filterData).forEach(key => {
        props.filterData[key] = null;
    });
    filterKey.value += 1;
};


const clearDates = (filterItem) => {
    props.filterData[filterItem?.models?.startDate] = null
    props.filterData[filterItem?.models?.endDate] = null
}

onMounted(() => {
    props.filterConfig.fields.forEach((item) => {
        if (item.type && (item.type === 'remoteOptions' || item.type === 'customOptions') && (!item?.options || item?.options.length === 0)) {
            getRemoteOptions(item.route, item);
        }
    });
    checkScreen();
    window.addEventListener("resize", checkScreen);
})
onUnmounted(() => {
    window.removeEventListener("resize", checkScreen);
});

</script>
<style>
.hrm_filter_grid {
    grid-template-columns: repeat(5, 1fr);
    row-gap: 10px;
}

.hrm_filter_grid input,
.hrm-vuemultiselect input,
.hrm-vuemultiselect {
    border-radius: 0 !important;
}

.hrm_filter_grid input,
.hrm_filter_grid .hrm_input_label {}

.hrm_selected_value .hrm-vuemultiselect {
    border: 1px solid var(--hrm_Theme_Bg_Color) !important;
}

.hrm_filter_grid input.hrmInput::placeholder,
.hrm_filter_grid .multiselect-placeholder {
    color: #606771;
}

.hrm_filter_clear {
    height: 40px;
}
</style>